export const VIDEO = {
  STATE_SERVER_URL: import.meta.env.VITE_VIDEO_STATE_SERVER_URL as string,
};
